













































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import ky from 'ky'
import Form from '@/mixins/form'
import { getAllDatesOfMonth } from '@/utils/datetime'
import { Worker } from '@/types/user'
import { isDateString } from '@/types/utils'
import { ScheduleState } from '@/store/schedule/types'
import EventWorkerCheckboxInputGroup, {
  EventWorkerInputType
} from './EventWorkerCheckboxInputGroup.vue'
import { CreateSchedulePayload } from '@/api/schedule/types'
import { ScheduleEventType } from '@/constants/schedule'
import { LocalStorageKeys } from '@/constants/localStorage'

export const ROUTING_TYPE_CREATE = 'create'
export const ROUTING_TYPE_EDIT = 'edit'

const TODAY = dayjs()
const DEFAULT_SCHEDULE_START = TODAY
const DEFAULT_SCHEDULE_END = TODAY.add(1, 'minute')

@Component({
  components: {
    EventWorkerCheckboxInputGroup: EventWorkerCheckboxInputGroup,
    ScheduleTimeSelectInput: () =>
      import('@/components/scheduleForm/inputs/ScheduleTimeSelectInput.vue'),
    EventTypeRadioInput: () =>
      import('@/components/scheduleForm/inputs/EventTypeRadioInput.vue'),
    TextareaInput: () => import('@/components/common/inputs/TextareaInput.vue'),
    CheckboxInput: () => import('@/components/common/inputs/CheckboxInput.vue'),
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue'),
    RadioInput: () => import('@/components/common/inputs/RadioInput.vue'),
    TextInput: () => import('@/components/common/inputs/TextInput.vue'),
    InsertModal: () => import('@/components/scheduleForm/DataInsertModal.vue'),
    ImageList: () => import('@/components/scheduleForm/ImageList.vue'),
    DocumentList: () => import('@/components/scheduleForm/DocumentList.vue')
  }
})
export default class EditSchedule extends mixins(Form) {
  @Prop(Number) readonly patientId!: number
  @Prop(String) readonly routingType!: string
  @Prop(Object) readonly schedule?: ScheduleState | undefined
  @Prop({ default: () => [] }) readonly watchingWorkers!: Array<Worker>
  @Prop({ default: '' }) readonly preText!: string

  $store!: ExStore

  inputStartDate = {
    year: DEFAULT_SCHEDULE_START.year(),
    month: DEFAULT_SCHEDULE_START.month() + 1,
    date: DEFAULT_SCHEDULE_START.date(),
    hour: DEFAULT_SCHEDULE_START.hour(),
    minute: DEFAULT_SCHEDULE_START.minute()
  }

  inputEndDate = {
    hour: DEFAULT_SCHEDULE_END.hour(),
    minute: DEFAULT_SCHEDULE_END.minute()
  }

  inputEventWorkers = this.watchingWorkers.reduce(
    (options, worker) => ({
      ...options,
      [worker.id]: {
        value: this.eventWorkerIds.indexOf(worker.id) !== -1,
        name: `eventWorker_${worker.id}`
      }
    }),
    {} as EventWorkerInputType
  )

  inputEventType = ''
  inputIsNeedPerforme = false
  inputSubject = ''
  inputContent = this.preText
  inputNotifyByMessage = false

  visibleModal: 'image' | 'dicom' | 'document' | null = null
  patientName = ''

  @Watch('inputSubject')
  onChangeSubject(val: string) {
    if (this.routingType === ROUTING_TYPE_EDIT) return
    this.draft = { title: val }
  }
  @Watch('inputContent')
  onChangeContent(val: string) {
    if (this.routingType === ROUTING_TYPE_EDIT) return
    this.draft = { content: val }
  }

  get draft() {
    const blank = {
      title: '',
      content: ''
    }
    const draft = JSON.parse(
      sessionStorage.getItem(LocalStorageKeys.SCHEDULE_DRAFT) || 'null'
    )
    return draft ? draft : blank
  }

  set draft(d: { title?: string; content?: string }) {
    const saved = this.draft
    sessionStorage.setItem(
      LocalStorageKeys.SCHEDULE_DRAFT,
      JSON.stringify(Object.assign(saved, d))
    )
  }

  get scheduleTypes() {
    return this.$store.getters['scheduleType/scheduleTypes']
  }

  get eventWorkerIds() {
    if (!this.schedule) {
      return []
    }

    if (!Array.isArray(this.schedule.eventworkerSet)) {
      return []
    }

    return this.schedule.eventworkerSet.map(
      ({ worker }) => (worker as Worker).id
    )
  }

  get selectOptionYears() {
    const thisYear = TODAY.year()
    return [0, 1].map(i => i + thisYear)
  }

  get selectOptionMonths() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  }

  get selectOptionDates() {
    const { year, month } = this.inputStartDate
    return getAllDatesOfMonth(year, month)
  }

  get selectOptionHours() {
    return [...new Array(24)].map((i, j) => j)
  }

  get selectOptionMinutes() {
    return [...new Array(60)].map((i, j) => j)
  }

  checkAndResetDateIfNeeded() {
    if (this.inputStartDate.date > Math.max(...this.selectOptionDates)) {
      this.inputStartDate.date = 1
    }
  }

  get hasErrorStartDate() {
    const fields = [
      'startDateYear',
      'startDateMonth',
      'startDateDate',
      'startHour',
      'startMinute'
    ]

    return fields.some(name => {
      const { required } = this.validator.evaluators[name] || {}

      return required !== undefined && !required
    })
  }

  get errorMessageStartDate() {
    const fields = [
      'startDateYear',
      'startDateMonth',
      'startDateDate',
      'startHour',
      'startMinute'
    ]

    const name = fields.find(name => this.validator.messages[name]) as string

    return this.validator.messages[name]
  }

  get hasErrorEndDate() {
    const fields = ['endHour', 'endMinute']

    return fields.some(name => this.validator.errors[name])
  }

  get errorMessageEndDate() {
    const fields = ['endHour', 'endMinute']

    const name = fields.find(name => this.validator.messages[name]) as string

    return this.validator.messages[name]
  }

  async handleSubmit() {
    if (this.validator.hasAnyError()) {
      return
    }

    try {
      const params = this.buildRequestParameters()

      switch (this.routingType) {
        case ROUTING_TYPE_CREATE:
          await this.$store.dispatch('schedule/create', { params })
          this.$router.push({ name: 'Schedules' })
          sessionStorage.removeItem(LocalStorageKeys.SCHEDULE_DRAFT)
          break
        case ROUTING_TYPE_EDIT:
          await this.$store.dispatch('schedule/replace', {
            params,
            scheduleId: this.schedule!.id
          })
          this.$router.push({
            name: 'ScheduleComment',
            params: { patientId: String(this.patientId) }
          })
          return
        default:
          throw new Error(
            `routingType value of '${this.routingType}' is not defined`
          )
      }
    } catch (error) {
      if (error instanceof ky.HTTPError) {
        if (error.response.status === 404) {
          this.$router.push('/404')
          return
        }
      }
      // 例外処理
    }
  }

  buildRequestParameters() {
    const date = dayjs(
      new Date(
        this.inputStartDate.year,
        this.inputStartDate.month - 1,
        this.inputStartDate.date
      )
    ).format('YYYY-MM-DD')

    if (!isDateString(date)) {
      throw new Error(
        'date value is invalid. The value must be type of DateString'
      )
    }

    const eventworkerSet = Object.keys(this.inputEventWorkers)
      .filter(id => this.inputEventWorkers[Number(id)].value)
      .map(id => Number(id))

    const params: CreateSchedulePayload = {
      date,
      eventworkerSet,
      startHour: this.inputStartDate.hour,
      startMinute: this.inputStartDate.minute,
      endHour: this.inputEndDate.hour,
      endMinute: this.inputEndDate.minute,
      eventType: this.inputEventType,
      isNeedPerform: this.inputIsNeedPerforme,
      subject: this.inputSubject,
      content: this.inputContent,
      patient: this.patientId
    }

    if (this.inputIsNeedPerforme) {
      params.notifyByMessage = this.inputNotifyByMessage
    }

    return params
  }

  initializeFormInputs() {
    this.inputEventType = (this.scheduleTypes[0] || {}).eventType

    if (this.routingType === ROUTING_TYPE_CREATE) {
      return
    }

    const {
      date,
      startHour,
      startMinute,
      endHour,
      endMinute,
      eventType,
      isNeedPerform,
      subject,
      content
    } = this.schedule as ScheduleState

    const scheduleDate = dayjs(date)
    this.inputStartDate.year = scheduleDate.year()
    this.inputStartDate.month = scheduleDate.month() + 1
    this.inputStartDate.date = scheduleDate.date()
    this.inputStartDate.hour = startHour
    this.inputStartDate.minute = startMinute
    this.inputEndDate.hour = endHour
    this.inputEndDate.minute = endMinute

    this.inputSubject = subject
    this.inputContent = content
    this.inputEventType = eventType
    this.inputIsNeedPerforme = isNeedPerform
  }

  async created() {
    this.initializeFormInputs()
    this.patientName = await this.getPatientName()
    if (this.routingType === ROUTING_TYPE_CREATE) this.insertSessionData()
  }

  insertSessionData() {
    console.log(this.draft)
    this.inputSubject = this.draft.title || this.inputSubject
    this.inputContent = this.draft.content || this.inputContent
  }

  async getPatientName() {
    try {
      const patient = await this.$api.user.patient({
        patientId: this.patientId
      })
      return `${patient.lastName}${patient.firstName}`
    } catch (e) {
      console.error(e)
      return ''
    }
  }

  insertData(type: 'document' | 'image' | 'dicom', ids: number[]) {
    this.visibleModal = null
    const dataText = [...ids.map(id => `\n[${type}:${id}]`), '\n']
    const textarea = document.getElementById('content') as HTMLTextAreaElement
    const start = textarea.selectionStart
    const end = textarea.selectionEnd
    const textArray = this.inputContent ? [...this.inputContent] : []
    textArray.splice(start, end - start, dataText.join(''))
    this.inputContent = textArray.join('')
  }
}
